import { z } from 'zod';

export const SistemaLayoutSchema = z.object({
    sic_botao: z.string().nullable(),
    sic_botao_fundo: z.string().nullable(),
    sic_botao_fundo_info: z.string().nullable(),
    sic_botao_fundo_sucesso: z.string().nullable(),
    sic_botao_texto: z.string().nullable(),
    sic_card_fundo: z.string().nullable(),
    sic_card_texto: z.string().nullable(),
    sic_cor_primaria: z.string(),
    sic_cor_secundaria: z.string().nullable(),
    sic_cor_sistema_nome: z.string(),
    sic_cor_terciaria: z.string().nullable(),
    sic_idpk: z.number(),
    sic_menu: z.string().nullable(),
    sic_menu_titulo: z.string().nullable(),
    sic_sistema_fundo: z.string(),
    sic_sistema_idpk: z.number(),
    sic_tema: z.enum(['default', 'dark']),
});

export type SistemaLayout = z.infer<typeof SistemaLayoutSchema>;

export type ApiSistema = {
    layout: SistemaLayout;
    sis_idpk: number;
    sis_nome_sistema: string;
    sis_email: string;
    sis_base_url: string;
    sis_integracao_boleto: string;
    sis_integracao_pix: string;
    sis_integracao_cartao: string;
    sis_conta_digital: string;
} & Partial<{
    sis_responsavel: string;
    sis_telefone: string;
    sis_copyright: string;
    sis_empresa: string;
    sis_cnpjcpf: string;
    sis_observacoes: string;
    sis_logotipo: string;
    sis_logo_svg: string;
    sis_banner_fundo: string;
    sis_facebook: string;
    sis_instagram: string;
    sis_youtube: string;
    sis_documentacao_api: string;
    sis_icone: string;
    sis_titulo: string;
    sis_landing_page: string;
    sis_representante_padrao: number;
    sis_termos_de_uso: string;
    sis_politica_de_privacidade: string;
    sis_ultima_alteracao: string;
    sis_sistema_tipo_uso_padrao: number;
}>;
